export default __webpack_public_path__ + "assets/fonts/a66592339469c4fde13eb0793c0a62f7.woff";